import details from './details/index.vue'
import measure from './measure/index.vue'
export default {
  details,
  measure
}
